var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import { Div } from './div';
import React from 'react';
import { VscError, AiOutlineClose, AiOutlineInfoCircle, AiOutlineWarning } from '../../icons';
import { Col, Row, Spacer } from '../Grid';
import { Label } from '../Text';
import { Render } from '../Render';
import { Button } from '../Button';
var Variants = {
    info: {
        icon: AiOutlineInfoCircle,
        props: {
            color: 'blue-3',
            textColor: 'white',
        }
    },
    error: {
        icon: VscError,
        props: {
            color: 'red-3',
            textColor: 'white',
        }
    },
    warning: {
        icon: AiOutlineWarning,
        props: {
            color: 'orange-3',
            textColor: 'white',
        }
    }
};
export var Alert = React.forwardRef(function (_a, ref) {
    var children = _a.children, contentLeft = _a.contentLeft, contentRight = _a.contentRight, content = _a.content, title = _a.title, _b = _a.type, type = _b === void 0 ? 'info' : _b, info = _a.info, error = _a.error, warning = _a.warning, _c = _a.dismissible, dismissible = _c === void 0 ? false : _c, onDismiss = _a.onDismiss, props = __rest(_a, ["children", "contentLeft", "contentRight", "content", "title", "type", "info", "error", "warning", "dismissible", "onDismiss"]);
    var forwardRef = React.useRef(null);
    React.useEffect(function () { if (ref) {
        if (typeof ref === "function") {
            ref(forwardRef.current);
        }
        else {
            ref.current = forwardRef.current;
        }
    } });
    if (info)
        type = 'info';
    if (error)
        type = 'error';
    if (warning)
        type = 'warning';
    var variant = Variants[type];
    var Icon = variant.icon;
    return _jsx(_Fragment, { children: _jsx(Div, __assign({ display: 'inline-block', borderRadius: 3, padding: 5 }, variant === null || variant === void 0 ? void 0 : variant.props, props, { ref: forwardRef }, { children: _jsxs(Row, __assign({ columns: true, noWrap: true }, { children: [_jsx(Col, __assign({ show: Boolean(title) }, { children: _jsxs(Row, { children: [_jsx(Col, __assign({ center: true, gutter: true }, { children: _jsx(Icon, { size: 20 }) })), _jsx(Spacer, __assign({ center: true, gutter: true }, { children: _jsx(Render, { ifString: function (_a) {
                                            var text = _a.text;
                                            return _jsx(Label, { xxsmall: true, bold: true, label: text });
                                        }, content: title }) })), _jsx(Col, __assign({ start: true, gutter: true, show: dismissible }, { children: _jsx(Button, __assign({ noneTheme: true, text: true, noFocuseable: true, borderRadius: 5, padding: 2, minHeight: 0, textColor: "white", onClick: onDismiss }, { children: _jsx(AiOutlineClose, { size: 18 }) })) }))] }) })), _jsx(Col, { children: _jsxs(Row, { children: [_jsx(Col, __assign({ start: true, gutter: true, hidden: Boolean(title) }, { children: _jsx(Icon, { size: 20 }) })), _jsx(Col, __assign({ center: true, gutter: true, hidden: !contentLeft }, { children: contentLeft && contentLeft })), _jsxs(Spacer, __assign({ center: true, gutter: true }, { children: [_jsx(Render, { ifString: function (_a) {
                                                var text = _a.text;
                                                return _jsx(Label, { xxsmall: true, label: text });
                                            }, content: content }), _jsx(Render, { ifString: function (_a) {
                                                var text = _a.text;
                                                return _jsx(Label, { xxsmall: true, label: text });
                                            }, content: children })] })), _jsx(Col, __assign({ center: true, gutter: true, hidden: !contentLeft }, { children: contentRight && contentRight })), _jsx(Col, __assign({ start: true, gutter: true, hidden: Boolean(title) || !dismissible }, { children: _jsx(Button, __assign({ noneTheme: true, text: true, noFocuseable: true, borderRadius: 5, padding: 2, minHeight: 0, textColor: "white", onClick: onDismiss }, { children: _jsx(AiOutlineClose, { size: 18 }) })) }))] }) })] })) })) });
});
